import { createQueryKeys } from '@lukemorales/query-key-factory';
import { useMutation, useQuery, UseQueryOptions } from '@tanstack/react-query';
import { SMSTemplateApi } from 'api';
import type { SMSTemplate } from 'api/methods/SMSTemplateApi';

/**
 * [SMSTemplate] Query key 생성
 * --
 */
export const SMSTemplateQueryKeys = createQueryKeys('SMSTemplate', {
  getSMSTemplate: (
    idx: number,
    params?: { [key: string]: string | number }
  ) => [idx, params],
  getSMSTemplates: (params?: { [key: string]: string | number }) => [params],
});

/**
 * [SMSTemplate] 문자 탬플릿 전체 조회
 * --
 */
export const useGetSMSTemplates = (
  params?: { [key: string]: string | number },
  options?: UseQueryOptions<any, any>
) => {
  const data = useQuery({
    queryKey: SMSTemplateQueryKeys.getSMSTemplates(params).queryKey,
    queryFn: () => SMSTemplateApi.getSMSTemplates(params),
    ...options,
  });
  return data;
};

/**
 * [SMSTemplate] 문자 탬플릿 상세 조회
 * --
 */
export const useGetSMSTemplate = (
  idx: number,
  params?: { [key: string]: string | number }
) => {
  const data = useQuery({
    queryKey: SMSTemplateQueryKeys.getSMSTemplate(idx, params).queryKey,
    queryFn: () => SMSTemplateApi.getSMSTemplate(idx, params),
  });

  return data;
};

/**
 * [SMSTemplate] 문자 탬플릿 생성
 * --
 */
export const useCreateSMSTemplate = (body: SMSTemplate) => {
  const { mutateAsync: createSMSTemplate, ...result } = useMutation({
    mutationFn: (variables: SMSTemplate) =>
      SMSTemplateApi.createSMSTemplate(variables),
    onSuccess: (data, variables) => {
      console.log(data, variables);
    },
    onError: (error) => {
      console.error(error);
    },
  });

  return { createSMSTemplate, ...result };
};

/**
 * [SMSTemplate] 문자 탬플릿 수정
 * --
 */
export const useUpdateSMSTemplate = (body: SMSTemplate) => {
  const { mutateAsync: updateSMSTemplate, ...result } = useMutation({
    mutationFn: (variables: SMSTemplate) =>
      SMSTemplateApi.updateSMSTemplate(variables),
    onSuccess: (data, variables) => {
      console.log(data, variables);
    },
    onError: (error) => {
      console.error(error);
    },
  });

  return { updateSMSTemplate, ...result };
};

/**
 * [SMSTemplate] 문자 탬플릿 삭제
 * --
 */
export const useDeleteSMSTemplate = (idx: number) => {
  const { mutateAsync: deleteSMSTemplate, ...result } = useMutation({
    mutationFn: (variables: number) =>
      SMSTemplateApi.deleteSMSTemplate(variables),
    onSuccess: (data, variables) => {
      console.log(data, variables);
    },
    onError: (error) => {
      console.error(error);
    },
  });

  return { deleteSMSTemplate, ...result };
};
